<template>
  <div>
    <base-modal
      :showing="visible"
      @close="$emit('close')"
      size="max-w-5xl"
      @opened="onOpened"
    >
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div>
            <h3 class="text-lg font-bold leading-6 text-gray-900">
              Daftar User Untuk Role {{ role.data.attributes.name }}
            </h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              Daftar User Yang Tersedia
            </p>
          </div>
        </div>
      </div>
      <div class="mt-6 space-y-4 border-t border-gray-200 pt-6">
        <div class="flex justify-end gap-2">
          <base-input
            :shadow="false"
            placeholder="Cari user"
            debounce
            type="text"
            v-model="filter.search"
            @native-input="onFilter"
          />
          <base-button v-if="users.data.length > 0" color="danger" @click="$emit('delete-all-user')">
            <Icon icon="heroicons:trash-solid" class="w-4 h-4" />
            Hapus Semua
          </base-button>
        </div>
        <datatable
          :columns="columns"
          :scroll-x="false"
          :total="users.meta.page.total"
          :perPage="users.meta.page.perPage"
          :currentPage="users.meta.page.currentPage"
          @pagechanged="onPageChanged"
        >
          <template v-slot:tbody="{ classes }">
            <tr
              v-for="user in users.data"
              :key="user.id"
              :class="[classes.tr, 'hover:bg-gray-50']"
            >
              <td :class="[classes.td]">
                <div class="space-y-1">
                  <p class="font-bold text-gray-900">
                    {{ user.attributes.name }}
                  </p>
                  <p class="text-xs">{{ user.attributes.email }}</p>
                </div>
              </td>
              <td :class="[classes.td]">
                {{ user.attributes.office_type }}
              </td>
              <td :class="[classes.td]">
                <span v-if="!user.relationships.user.data">-</span>
                <template v-else>
                  <div class="flex items-center gap-x-2">
                    <span>{{
                      getSingleIncludedType(
                        'office',
                        users,
                        getSingleIncludedType('user', users, user)
                      ).attributes.code
                    }}</span>
                  </div>
                </template>
              </td>
              <td :class="[classes.td]">
                {{ user.attributes.last_active | formatDate }}
              </td>
              <td :class="[classes.td]">
                <button
                  class="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-gray-100"
                  @click="$emit('delete-user', user.relationships.user.data.id)"
                >
                  <Icon icon="heroicons:trash-solid" class="w-4 h-4" />
                </button>
              </td>
            </tr>
          </template>
        </datatable>
      </div>
    </base-modal>
    <loading v-if="loading" />
  </div>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import BaseModal from '@/components/base/BaseModal.vue';

export default {
  mixins: [requestMixin],
  components: { BaseModal },
  props: {
    visible: Boolean,
    roleId: String,
    reload: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close', 'delete-user', 'delete-all-user'],
  data() {
    return {
      loading: false,
      users: {
        data: [],
        meta: {
          page: {},
        },
      },
      role: {
        data: {
          attributes: {
            name: null,
          },
        },
      },
      filter: {
        search: null,
      },
    };
  },
  computed: {
    columns() {
      return [
        { id: 'name', name: 'Nama' },
        { id: 'office_type', name: 'Tipe User' },
        { id: 'office', name: 'Office' },
        { id: 'last_login', name: 'Terakhir Login' },
        { id: 'action', name: 'Aksi' },
      ];
    },
  },
  methods: {
    async onOpened() {
      if (this.reload) {
        this.loading = true;

        this.filter.search = null;

        await this.loadRole();
        await this.loadUsers();

        this.loading = false;
      }
    },
    async onPageChanged(page) {
      this.loading = true;

      await this.loadUsers({
        'page[number]': page,
      });

      this.loading = false;
    },
    async onFilter() {
      this.loading = true;

      await this.loadUsers({});

      this.loading = false;
    },
    async loadRole() {
      const [res, error] = await this.request(`/api/v1/roles/${this.roleId}`, {
        params: {
          'fields[roles]': 'name',
        },
      });

      if (!error) {
        this.role = res;
      }

      return [res, error];
    },
    async loadUsers(params) {
      const [res, error] = await this.request(`/api/v1/users`, {
        params: {
          'sort': 'id,createdAt',
          'page[size]': 5,
          'pagination[type]': 'default',
          'filter[search]': this.filter.search,
          include: 'user.office',
          'fields[simple-users]': 'name,email,office_type,last_active,user,user_id',
          'fields[users]': 'office',
          'fields[offices]': 'code',
          'filter[current_role_uuid]': this.role.data.id,
          ...params,
        },
      });

      if (!error) {
        this.users = res;
      }

      return [res, error];
    },
  },
};
</script>
